import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.css']
})
export class ButtonComponent implements OnInit {
  @Input() type = 'primary'
  @Input() disabled = false;

  constructor() { }

  ngOnInit() {
  }

  getClass(){
    switch(this.type){
      case 'primary':
        return 'btn-primary violet';
      case 'secondary':
        return 'btn-primary sea-green';
      case 'tertiary':
        return '';
    }
  }

}
